import React, { memo } from "react";
import { Outlet } from "react-router-dom";

export const DefaultLayout = memo(function DefaultLayout({ metaTitle = "" }) {
  return (
    <>
      <Outlet />
    </>
  );
});
